/*
We removed isFeatureToggleEnabled from the @newsenec/micro-frontend-manager
This change requires to adjust how we bootstrap the notifications feature, because this feature is disabled since almost a year and maybe gets deleted soon.
We decided to just comment it out for now to continue with the deletion of the deprecated method from @newsenec/micro-frontend-manager

import { registerCurrentUser } from "./register-user"
import { getUser, KeycloakRole } from "@newsenec/auth-provider"
import { isFeatureToggleEnabled } from "@newsenec/micro-frontend-manager"
*/
export * from "./notification";

export function bootstrap(): Promise<void> {
    /*const user = getUser()

    user.then((user) => {
        return isFeatureToggleEnabled("fp-1225_notification_bell").then(() => {
            if (user?.keycloakRoles?.includes(KeycloakRole.Installer)) {
                return registerCurrentUser()
            }
        })
    })*/

    return Promise.resolve();
}
